import { NgClass } from '@angular/common';
import { Component, Output, EventEmitter, InjectionToken, Inject, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { easeInOutAnimation } from '../../utils/animation/animation';

import { NotificationsToast, NotificationsToastConfiguration } from './notifications-toast.domain';
import { NotificationToastWrapperComponent } from './toast/notification-toast-wrapper.component';
export const NOTIFICATIONS_TOAST_CONFIGURATION = new InjectionToken<NotificationsToastConfiguration>('notificationsToastComponentData');

@Component({
  selector: 'td-wb-notifications-toast-container',
  templateUrl: './notifications-toast-container.component.html',
  styleUrls: ['./notifications-toast-container.component.scss'],
  imports: [
    NotificationToastWrapperComponent,
    NgClass
  ],
  animations: [easeInOutAnimation]

})
export class NotificationsToastContainerComponent {

  private static readonly MAX_NOTIFICATION_COUNT: number = 4;

  @Input() expiryDuration: number = 7000;
  @Output() readonly onClose: EventEmitter<unknown> = new EventEmitter<unknown>();

  readonly toasts: Array<NotificationsToast> = [];

  excessMessageCount: number = 0;
  excessToast: NotificationsToast;

  private notificationsSubscription: Subscription;

  /**
   * Set Observable for subscribe to new notifications
   */
  constructor(@Inject(NOTIFICATIONS_TOAST_CONFIGURATION) configuration: NotificationsToastConfiguration) {
    if (configuration !== null && configuration !== undefined) {
      if (configuration.preferences !== undefined && configuration.preferences.notificationFadeOutTime !== undefined) {
        this.expiryDuration = configuration.preferences.notificationFadeOutTime * 1000;
      }
      if (configuration.notifications !== undefined) {
        this.notificationsSubscription = configuration.notifications.subscribe((toast: NotificationsToast): void => {
          this.onNewNotification(toast);
        });
      }
    }
  }

  /**
   * Close toast container
   */
  close(): void {
    if (this.notificationsSubscription !== undefined) {
      this.notificationsSubscription.unsubscribe();
    }
    this.onClose.emit();
  }

  /**
   * Close toast on expiry
   */
  closeToast(toast: NotificationsToast): void {
    const index = this.toasts.findIndex((x: NotificationsToast): boolean => x === toast);
    this.onNotificationExpiry(index);
  }

  /**
   * Track by for toast list
   */
  trackByNotifications(_: number, item: NotificationsToast): string {
    return item.id;
  }

  private onNewNotification(toast: NotificationsToast): void {
    if (this.toasts.length < NotificationsToastContainerComponent.MAX_NOTIFICATION_COUNT) {
      this.toasts.unshift(toast);
    } else {
      this.excessToast = toast;
      this.excessMessageCount++;
    }
  }

  private onNotificationExpiry(index: number): void {
    if (index >= 0) {
      this.toasts.splice(index, 1);
    } else {
      // close excess notifications message
      this.excessToast = undefined;
      this.excessMessageCount = 0;
    }
    if (this.toasts.length === 0) {
      this.close();
    }
  }
}
